import { normalizeUppercase } from '@cbgms/base/utils/normalizers'
import { isValidBIC, isValidCOC, isValidIBAN, useVATFieldValidation } from '@cbgms/base/utils/validations'
import Input from '@cbgms/components/form/Input'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Form } from 'semantic-ui-react'

interface FinancialProps {
  country: string
}

const Financial: React.FC<FinancialProps> = ({ country }) => {
  const { t } = useTranslation()
  const vatValidation = useVATFieldValidation(country)

  return (
    <React.Fragment>
      <Form.Group widths='equal'>
        <Input
          label={t('shop.bank_account_iban')}
          maxLength='34'
          name='Shop.BankAccountIBAN'
          validate={isValidIBAN}
          normalize={normalizeUppercase}
        />
        <Input
          label={t('shop.bank_account_bic')}
          maxLength='11'
          name='Shop.BankAccountBIC'
          validate={isValidBIC}
          normalize={normalizeUppercase}
        />
      </Form.Group>
      <Form.Group widths='equal'>
        <Input label={t('shop.coc_identification')} maxLength='20' name='Shop.COCIdentification' validate={isValidCOC} />
        <Input
          label={t('shop.vat_identification')}
          name='Shop.VATIdentification'
          maxLength={vatValidation.maxLength}
          validate={vatValidation.validator}
        />
      </Form.Group>
    </React.Fragment>
  )
}

Financial.displayName = 'Financial'

export default Financial
